/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable, tap} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  AdminObjectState,
  SignalAdminResourceApiBase,
  SignalAdminResourceListParams,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';
import {CustomEventCacheService} from './custom-event-cache.service';

export type CustomEventObjectState = AdminObjectState;
export type CustomEventListParams = SignalAdminResourceListParams;

export interface CustomEventModel {
  id: string;
  name?: string;
  description?: string;
  valueType?: string;
  conversionType?: string | null;
  type?: string;
  priority?: number;
  objectState?: CustomEventObjectState;
  validationWarnings?: any[];
  url?: string;
}

export type CustomEventPage = SignalAdminResourcePage<CustomEventModel>;

@Injectable({providedIn: 'root'})
export class CustomEventApiService extends SignalAdminResourceApiBase<CustomEventModel> {
  constructor(client: AdnApiClientService, private readonly cache: CustomEventCacheService) {
    super(client, 'customeventtypes');
  }

  override save(model: CustomEventModel): Observable<CustomEventModel> {
    return super.save(model).pipe(tap((saved) => this.cache.update(saved)));
  }
}
